<template>
  <canvas ref="canvasRef" class="template_thumb" :style="{ aspectRatio: aspectRatio }"></canvas>
</template>

<script setup>
import { ref, computed, watch, onMounted, defineProps } from 'vue';
import { FORMATS } from '@/image-generator/presets';
import { renderTemplate } from '@/image-generator/renderer';

const props = defineProps({
  format: { type: String, required: true },
  config: { type: Object, required: true },
  data: { type: Object, required: true },
});

const canvasRef = ref(null);

/* Proporção fixa: sem ela o canvas fica 300x150 até a foto carregar e a faixa pula. */
const aspectRatio = computed(() => FORMATS[props.format].width + ' / ' + FORMATS[props.format].height);

function render() {
  if (canvasRef.value) {
    renderTemplate(canvasRef.value, props.format, props.config, props.data, 0.15);
  }
}

watch(() => [props.format, props.config, props.data], render, { deep: true });

onMounted(render);
</script>

<style scoped>
.template_thumb {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  background-color: #ddd;
}

.dark .template_thumb {
  background-color: #3a414f;
}
</style>
